

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
require('es6-promise').polyfill()


import Axios from './plugin/axios'
import CheckResp from '../../assets/plugin/checkResp'
import handleError from '../../assets/plugin/handleError'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'




sync(store, router)

Vue.use(Axios)
Vue.use(CheckResp)
Vue.use(handleError)
Vue.use(LoadingPlugin)
Vue.use(ToastPlugin)
Vue.use(ConfirmPlugin)
sessionStorage.clear()
router.beforeEach((to, from, next) => {
if (to.meta && to.meta.title) {
document.title = to.meta.title
}
if (!sessionStorage.getItem('hfs-wechat-current-url')) {
sessionStorage.setItem('hfs-wechat-current-url', document.URL)
}
next()
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
template: '<App/>',
components: { App }
})



// WEBPACK FOOTER //
// ./src/views/ReportApp/app.js